/**
 * Календарный день даты в локальном времени браузера в форме ГГГГ-ММ-ДД:
 * ключ группировки по дню и значение для поля выбора даты.
 */
export function formatLocalDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}
